import { DollarOutlined, UserOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { ReactNode } from 'react'

import { PoolListOverview, TokenAmount } from '../types'

type Props = {
  data: PoolListOverview
}

const formatUsd = (value: number) =>
  `$${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value)}`

const formatTokenLine = (row: TokenAmount): ReactNode => {
  if (row.amount == null) {
    return (
      <Tooltip title="Could not read from chain">
        <span>Unavailable {row.symbol}</span>
      </Tooltip>
    )
  }
  return `${new Intl.NumberFormat('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(row.amount)} ${row.symbol}`
}

const cardsOf = (data: PoolListOverview): Array<{ label: string; value: ReactNode; icon: ReactNode }> => [
  {
    label: 'Total Value Staked',
    value: formatUsd(data.totalValueStakedUsd),
    icon: <DollarOutlined />,
  },
  {
    label: 'Total Stakers',
    value: new Intl.NumberFormat('en-US').format(data.totalStakers),
    icon: <UserOutlined />,
  },
    {
      label: 'Total Reward Claimed',
      value: data.rewardClaimed.map((row) => <div key={row.symbol}>{formatTokenLine(row)}</div>),
      icon: <DollarOutlined />,
    },
    {
      label: 'Estimate Reward Available Claim',
      value: data.rewardUnclaimed.map((row) => <div key={row.symbol}>{formatTokenLine(row)}</div>),
      icon: <DollarOutlined />,
    },
]

const OverviewCards = ({ data }: Props) => {
  return (
    <div className="dashboard-container">
      <div className="wrap-dashboard">
        <div className="wrap-box">
          <div className="title">Staked Overview</div>
          <div className="wrap-columns">
            <div className="columns">
              {cardsOf(data).map((card) => (
                <div className="colum w-3" key={card.label}>
                  <div className="guide-box">
                    <div className="box-content">
                      <div className="left-s">
                        <div className="txt">{card.label}</div>
                        <div className="number">{card.value}</div>
                      </div>
                      <div className="right-s">
                        <div className="icon">{card.icon}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OverviewCards
